// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cursur-pointer[data-v-d721f91c]{cursor:pointer}", ""]);
// Exports
module.exports = exports;
